import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_ADMISSION_FAILURE,
  ADD_ADMISSION_REQUEST,
  ADD_ADMISSION_SUCCESS,
  DELETE_ADMISSION_FAILURE,
  DELETE_ADMISSION_REQUEST,
  DELETE_ADMISSION_SUCCESS,
  FETCH_ADMISSION_FAILURE,
  FETCH_ADMISSION_PATIENT_FAILURE,
  FETCH_ADMISSION_PATIENT_REQUEST,
  FETCH_ADMISSION_PATIENT_SUCCESS,
  FETCH_ADMISSION_REQUEST,
  FETCH_ADMISSION_SUCCESS,
  FETCH_ALL_LIST_ADMISSIONS_FAILURE,
  FETCH_ALL_LIST_ADMISSIONS_REQUEST,
  FETCH_ALL_LIST_ADMISSIONS_SUCCESS,
  FETCH_ALLS_LIST_ADMISSIONS_FAILURE,
  FETCH_ALLS_LIST_ADMISSIONS_REQUEST,
  FETCH_ALLS_LIST_ADMISSIONS_SUCCESS,
  FETCH_LIST_ADMISSIONS_FAILURE,
  FETCH_LIST_ADMISSIONS_REQUEST,
  FETCH_LIST_ADMISSIONS_SUCCESS,
  FETCH_REPORT_LIST_ADMISSIONS_FAILURE,
  FETCH_REPORT_LIST_ADMISSIONS_REQUEST,
  FETCH_REPORT_LIST_ADMISSIONS_SUCCESS,
  RESET_CURRENT_ADMISSION,
  UPDATE_ADMISSION_FAILURE,
  UPDATE_ADMISSION_REQUEST,
  UPDATE_ADMISSION_SUCCESS,
} from "./admissionsType";

const initialState = {
  admissions: [],
  currentAdmission: null,
  fetchAdmissions: { ...defaultStatus },
  fetchAdmissionsAll: { ...defaultStatus },
  fetchAllAdmissions: { ...defaultStatus },
  fetchReport: { ...defaultStatus },
  fetchAdmission: { ...defaultStatus },
  fetchAdmissionPatients: { ...defaultStatus },
  addAdmission: { ...defaultStatus },
  updateAdmission: { ...defaultStatus },
  deleteAdmission: { ...defaultStatus },
  formMode: null,
};

const AdmissionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_LIST_ADMISSIONS_REQUEST:
      return {
        ...state,
        fetchAdmissionsAll: { ...state.fetchAdmissionsAll, inProgress: true },
      };
    case FETCH_LIST_ADMISSIONS_SUCCESS:
      return {
        ...state,
        fetchAdmissionsAll: {
          ...state.fetchAdmissionsAll,
          success: true,
          inProgress: false,
          admissions: payload?.admissions?.data,
        },
      };
    case FETCH_LIST_ADMISSIONS_FAILURE:
      return {
        ...state,
        fetchAdmissionsAll: {
          ...state.fetchAdmissionsAll,
          error: true,
          errorMessage: payload.error,
        },
      };
    case FETCH_ALLS_LIST_ADMISSIONS_REQUEST:
      return {
        ...state,
        fetchAdmission: { ...state.fetchAdmission, inProgress: true },
      };
    case FETCH_ALLS_LIST_ADMISSIONS_SUCCESS:
      return {
        ...state,
        fetchAllAdmission: {
          ...state.fetchAllAdmission,
          success: true,
          inProgress: false,
          admissions: payload?.admissions?.data,
        },
      };
    case FETCH_ALLS_LIST_ADMISSIONS_FAILURE:
      return {
        ...state,
        fetchAllAdmissions: {
          ...state.fetchAllAdmissions,
          error: true,
          errorMessage: payload.error,
        },
      };
    case FETCH_ALL_LIST_ADMISSIONS_REQUEST:
      return {
        ...state,
        fetchAdmissions: { ...state.fetchAdmissions, inProgress: true },
      };
    case FETCH_ALL_LIST_ADMISSIONS_SUCCESS:
      return {
        ...state,
        fetchAllAdmissions: {
          ...state.fetchAllAdmissions,
          success: true,
          inProgress: false,
          admissions: payload?.admissions?.data,
        },
      };
    case FETCH_ALL_LIST_ADMISSIONS_FAILURE:
      return {
        ...state,
        fetchAllAdmissions: {
          ...state.fetchAllAdmissions,
          error: true,
          errorMessage: payload.error,
        },
      };

    case FETCH_REPORT_LIST_ADMISSIONS_REQUEST:
      return {
        ...state,
        fetchReport: { ...state.fetchAdmissions, inProgress: true },
      };
    case FETCH_REPORT_LIST_ADMISSIONS_SUCCESS:
      return {
        ...state,
        fetchReport: {
          ...state.fetchReport,
          success: true,
          inProgress: false,
          admissions: payload?.admissions?.data,
        },
      };
    case FETCH_REPORT_LIST_ADMISSIONS_FAILURE:
      return {
        ...state,
        fetchReport: {
          ...state.fetchReport,
          error: true,
          errorMessage: payload?.error,
        },
      };
    case FETCH_ADMISSION_REQUEST:
      const { admissionId } = payload;
      return {
        ...state,
        fetchAdmission: {
          ...state.fetchAdmission,
          inProgress: true,
          admissionId,
        },
      };
    case FETCH_ADMISSION_SUCCESS:
      return {
        ...state,
        fetchAdmission: {
          ...state.fetchAdmission,
          success: true,
          inProgress: false,
          data: payload?.admissions,
        },
      };
    case FETCH_ADMISSION_FAILURE:
      return {
        ...state,
        fetchAdmission: {
          ...state.fetchAdmission,
          error: true,
          errorMessage: payload.error,
        },
      };

    case FETCH_ADMISSION_PATIENT_REQUEST:
      const { admissionIdS } = payload;
      return {
        ...state,
        fetchAdmissionPatients: {
          ...state.fetchAdmissionPatients,
          inProgress: true,
          admissionIdS,
        },
      };
    case FETCH_ADMISSION_PATIENT_SUCCESS:
      return {
        ...state,
        fetchAdmissionPatients: {
          ...state.fetchAdmissionPatients,
          success: true,
          inProgress: false,
          data: payload?.admissions,
        },
      };
    case FETCH_ADMISSION_PATIENT_FAILURE:
      return {
        ...state,
        fetchAdmissionPatients: {
          ...state.fetchAdmissionPatients,
          error: true,
          errorMessage: payload.error,
        },
      };

    case ADD_ADMISSION_REQUEST:
      return {
        ...state,
        addAdmission: { ...state.addAdmission, inProgress: true },
      };
    case ADD_ADMISSION_SUCCESS:
      return {
        ...state,
        addAdmission: {
          ...state.addAdmission,
          success: true,
          error: false,
          inProgress: false,
        },
      };
    case ADD_ADMISSION_FAILURE:
      return {
        ...state,
        addAdmission: {
          ...state.addAdmission,
          error: true,
          errorMessage: payload.error,
        },
      };

    case UPDATE_ADMISSION_REQUEST:
      return {
        ...state,
        updateAdmission: { ...state.updateAdmission, inProgress: true },
      };
    case UPDATE_ADMISSION_SUCCESS: {
      const updatedAdmission = payload.Admission;
      return {
        ...state,
        updateAdmission: {
          ...state.updateAdmission,
          success: true,
          inProgress: false,
        },
        admissions: state.admissions.map((admission) =>
          admission.id === updatedAdmission.id ? updatedAdmission : admission
        ),
        currentAdmission: updatedAdmission,
      };
    }
    case UPDATE_ADMISSION_FAILURE:
      return {
        ...state,
        updateAdmission: {
          ...state.updateAdmission,
          error: true,
          errorMessage: payload.error,
        },
      };

    case DELETE_ADMISSION_REQUEST:
      return {
        ...state,
        deleteAdmission: { ...state.deleteAdmission, inProgress: true },
      };
    case DELETE_ADMISSION_SUCCESS:
      return {
        ...state,
        deleteAdmission: {
          ...state.deleteAdmission,
          success: true,
          inProgress: false,
        },
        admissions: state.admissions.filter(
          (admission) => admission.id !== payload.AdmissionId
        ),
        currentAdmission:
          state.currentAdmission?.id === payload.AdmissionId
            ? null
            : state.currentAdmission,
      };
    case DELETE_ADMISSION_FAILURE:
      return {
        ...state,
        deleteAdmission: {
          ...state.deleteAdmission,
          error: true,
          errorMessage: payload.error,
        },
      };

    case RESET_CURRENT_ADMISSION:
      return { ...defaultStatus };

    default:
      return state;
  }
};

export default AdmissionReducer;
